import { Alert, Box } from "@mui/material";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router";

import { isDevelopment } from "@citrine/configuration";

import { useErrorStateContext } from "./error-boundary";
import * as sx from "./error-message.sx";

export function ErrorMessage({
  showStackTrace = isDevelopment,
  reloadDocument = true,
}: {
  showStackTrace?: boolean;
  reloadDocument?: boolean;
}) {
  const { error } = useErrorStateContext();

  return (
    <sx.ErrorPage>
      <sx.MessageBox>
        <sx.MessageContent>
          <FormattedMessage id="error.message" />
          {/* use a standard link to force a page reload */}
          <Link to="/" reloadDocument={reloadDocument}>
            <FormattedMessage id="error.direction" />
          </Link>
        </sx.MessageContent>
      </sx.MessageBox>
      {showStackTrace && (
        <sx.StackTrace>
          <Alert severity="info">
            {"This stacktrace will not be shown in production"}
          </Alert>
          <Alert severity="error">
            <Box sx={{ whiteSpace: "pre-wrap" }} data-testid="stack-trace">
              {error instanceof Error ? error.stack : null}
            </Box>
          </Alert>
        </sx.StackTrace>
      )}
    </sx.ErrorPage>
  );
}
